module.exports = __webpack_public_path__ + "img/snipers_1.74a988d.jpg";